import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { FormTokensService } from '@nrwl/rx-service-forms';

@Pipe({
  name: 'tokenToDiv',
})
export class TokenToDivPipe implements PipeTransform {
  constructor(
    private formTokensService: FormTokensService,
    private sanitizer: DomSanitizer,
  ) {}

  transform(value: string): SafeHtml {
    if (!value) {
      return value;
    }

    const tokens = this.formTokensService.tokens;

    const sanitizedValue = this.sanitizer.sanitize(SecurityContext.HTML, value) || '';

    const replacedValue = sanitizedValue.replace(/#(.*?)#/g, (match, tokenName) => {
      const foundToken = tokens.find((token) => token.name === match);
      if (foundToken) {
        return `<div contenteditable="false" class="non-editable-token">${foundToken.title}</div>`;
      }
      return match;
    });

    const result = this.sanitizer.bypassSecurityTrustHtml(replacedValue);
    return result;
  }
}
